export * from "./hotel-snapp-pay-badge";
